import { Button, ModalFooter } from '@ds';
import { useFormContext } from 'react-hook-form';

export const EditCaseModalFooter = ({ onClose }: { onClose: () => void }) => {
  const {
    formState: { isValid, isSubmitting },
  } = useFormContext();

  return (
    <ModalFooter>
      <Button isDisabled={isSubmitting} variant="light" onPress={onClose}>
        Discard
      </Button>
      <Button isDisabled={!isValid} isLoading={isSubmitting} type="submit" variant="solid">
        Save Changes
      </Button>
    </ModalFooter>
  );
};
